export default __webpack_public_path__ + "static/media/img_goods1.23b6c148.svg";